import type {
  GetPackagesRequestTypes,
  GetPackagesResponseTypes,
} from 'entities/document/api/types';
import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getPackages = async (params: GetPackagesRequestTypes) => {
  const query = stringifyUrlQuery(params);
  const url = `/api/v2/packages${query}`;
  const response = await apiAuthClient.get<GetPackagesResponseTypes>(url);

  return response.data;
};
